import i18next from "i18next";
// GRID

// const boxFillColor = "rgba(255,255,255,0.25)";
const boxFillColor = "rgba(255,255,255,0)";

const lanesHorizontal = [
  { label: "", labelAlign: "center", laneWidth: 100, labelStyle: {angle: 90}, boxFillColor },
  { label: "", labelAlign: "center", laneWidth: 100, labelStyle: {angle: 80}, boxFillColor },
  { label: "", labelAlign: "center", laneWidth: 100, labelStyle: {angle: 80}, boxFillColor },
  { label: "", labelAlign: "center", laneWidth: 100, labelStyle: {angle: 80}, boxFillColor },
  { label: "", labelAlign: "center", laneWidth: 100, labelStyle: {angle: 80}, boxFillColor},
  { label: "", labelAlign: "center", laneWidth: 100, labelStyle: {angle: 80}, boxFillColor },
  { label: "", labelAlign: "center", laneWidth: 100, labelStyle: {angle: 80}, boxFillColor },
  { label: "", labelAlign: "center", laneWidth: 100, labelStyle: {angle: 80}, boxFillColor },
];

const lanesVertical = [
  { label: "", laneWidth: 100, labelAlign: "center", labelStyle: {angle: 0}, boxFillColor, boxHeight: 0},
  { label: "", laneWidth: 100, labelAlign: "center", labelStyle: {angle: 0}, boxFillColor, boxHeight: 0},
  { label: "", laneWidth: 100, labelAlign: "center", labelStyle: {angle: 0}, boxFillColor, boxHeight: 0, shouldZoomBox: true},
  { label: "", laneWidth: 100, labelAlign: "center", labelStyle: {angle: 0}, boxFillColor, boxHeight: 0},
  { label: "", laneWidth: 100, labelAlign: "center", labelStyle: {angle: 0}, boxFillColor, boxHeight: 0},
  { label: "", laneWidth: 100, labelAlign: "center", labelStyle: {angle: 0}, boxFillColor, boxHeight: 0 },
  { label: "", laneWidth: 100, labelAlign: "center", boxFillColor, boxHeight: 0, shouldZoomBox: true, labelStyle: { borderRadius: 0, angle: 0 }},
  { label: "", laneWidth: 100, labelAlign: "center", labelStyle: {angle: 0}, boxFillColor, boxHeight: 0}
];

// TODO
const committed = {
  fillColor: "rgba(72,119,205,1)",
  title: "committed"
};
const supportive = {
  fillColor: "rgba(1,184,250,1)",
  title: "supportive"
};
const hesitant = {
  fillColor: "rgba(8,191,91,1)",
  title: "hesitant"
};
const neutral = {
  fillColor: "rgba(255,229,110,1)",
  title: "neutral"
};
const passive = {
  fillColor: "rgba(8,191,91,1)",
  title: "passive"
};
const opponent = {
  fillColor: "rgba(255,167,8,1)",
  title: "opponent"
};
const contrarian = {
  fillColor: "rgba(255,167,8,1)",
  title: "contrarian"
};
const adversary = {
  fillColor: "rgba(255,4,4,1)",
  title: "adversary"
};

const position_matrix = [
  [committed, committed, supportive, supportive, supportive, supportive, hesitant,  hesitant],
  [committed, committed, supportive, supportive, supportive, supportive, hesitant,  hesitant],
  [committed, committed, supportive, supportive, neutral,    neutral,    adversary, adversary],
  [committed, committed, supportive, neutral,    neutral,    neutral,    adversary, adversary],
  [committed, committed, neutral,    neutral,    neutral,    opponent,   adversary, adversary],
  [committed, committed, neutral,    neutral,    opponent,   opponent,   adversary, adversary],
  [passive,  passive,  contrarian, contrarian, contrarian, contrarian, adversary, adversary],
  [passive,  passive,  contrarian, contrarian, contrarian, contrarian, adversary, adversary],
]

const getPositions = () => {
  return { committed, supportive, hesitant, neutral, passive, opponent, contrarian, adversary }
}

const cellSettings = lanesVertical.map(x => lanesHorizontal.map(x => ({})));

position_matrix.forEach((rows, row_idx) => {
  rows.forEach((col, col_idx) => {
    cellSettings[col_idx][row_idx] = {fillColor: col.fillColor};
  })
})

// x, y are a percent should be between [0, 1[ but we accept 1 nonetheless
function inferPosition([x, y]) {
  // between 0 and 1
  const toIndex = (v) => v == 1 ? 7 : Math.floor(v * 8);

  return position_matrix[toIndex(y)][toIndex(x)].title;
}

// LEGEND //

const legend_nodes_data = [
  {
    "x": 700,
    "y": 750,
    "text": "adversaries",
    "fillColor": "rgba(137,123,117,1)"
  },
  {
    "x": 100,
    "y": 750,
    "text": "passives",
    "fillColor": "rgba(137,123,117,1)"
  },
  {
    "x": 400,
    "y": 750,
    "text": "contrarians",
    "fillColor": "rgba(137,123,117,1)"
  },
  {
    "x": 500,
    "y": 550,
    "text": "opponents",
    "fillColor": "rgba(137,123,117,1)"
  },
  {
    "x": 400,
    "y": 350,
    "text": "neutrals",
    "fillColor": "rgba(137,123,117,1)"
  },
  {
    "x": 700,
    "y": 50,
    "text": "hesitants",
    "fillColor": "rgba(137,123,117,1)"
  },
  {
    "x": 100,
    "y": 50,
    "text": "committed-plural",
    "fillColor": "rgba(137,123,117,1)"
  },
  {
    "x": 400,
    "y": 50,
    "text": "supportives",
    "fillColor": "rgba(137,123,117,1)"
  },
  {
    "x": -110,
    "y": 50,
    "text": "synergy",
    "fillColor": "rgba(72,119,205,1)"
  },
  {
    "x": 700,
    "y": 855,
    "text": "antagonism",
    "fillColor": "rgba(72,119,205,1)"
  },
  {
    "x": -40,
    "y": 825,
    "text": "",
    "fillColor": "rgba(137,123,117,1)"
  },
  {
    "x": -40,
    "y": -25,
    "text": "",
    "fillColor": "rgba(137,123,117,1)"
  },
  {
    "x": -25,
    "y": 835,
    "text": "",
    "fillColor": "rgba(137,123,117,1)"
  },
  {
    "x": 825,
    "y": 835,
    "text": "",
    "fillColor": "rgba(137,123,117,1)"
  }
];

// get so that is is rebuilt w/ i18next
const get_legend_nodes = () => legend_nodes_data.map((x, i) => {
  const item = {
    text: i18next.t(x.text),
    px: 0, py: 0, scaleWithZoom: true, hoverEffect: false,
    backgroundStyle: { lineColor: "transparent", fillColor: "transparent" },
    textStyle: { fillColor: x.fillColor, font: "28px Manrope-Medium" },
  };

  return {
    id: "inv" + i,
    x: x.x,
    y: x.y,
    locked: true,
    style: {label:"", fillColor: "transparent", draggable: false, items: [item], radius: 0}
  }
})

const legend_arrows  = [{
    "id": "l1",
    "from": "inv10",
    "to": "inv11",
    "style": {
      "fillColor":"rgba(72,119,205,1)",
      "toDecoration":"arrow"
    }
  },
  {
    "id": "l2",
    "from": "inv12",
    "to": "inv13",
    "style": {
      "fillColor": "rgba(72,119,205,1)",
      "toDecoration": "arrow"
    }
  }
];


export {
  legend_arrows,
  get_legend_nodes,
  lanesHorizontal,
  lanesVertical,
  cellSettings,
  getPositions,
  inferPosition
};
